import * as z from 'zod';

import { recruitingHiringCriteriaCategoryQueryLinkerSchema } from '@/_pages/settings/recruiting-hiring-criteria-categories/shared';
import { recruitingJobCategoryQueryLinkerSchema } from '@/_pages/settings/recruiting-job-categories/shared';
import { fileQuerySchema } from '@/_schemas/file';
import { emailSchema } from '@/_schemas/generic';
import { phoneNumberQuerySchema } from '@/_schemas/phone-numbers';

import { recruitingQuerySchema } from './recruiting-query-schema';

const tagsFormSchema = z.object({
  name: z.string(),
  value: z.string(),
});

export const recruitingFormSchema = recruitingQuerySchema
  .omit({
    email: true,
    profile_image: true,
    resume: true,
    additional_documents: true,
    recruiting_job_categories: true,
    hiring_criteria_categories: true,
    phone_numbers: true,
    recruiting_tags: true,
    notes: true,
  })
  .extend({
    email: emailSchema(),
    profile_image: z.array(fileQuerySchema),
    resume: z.array(fileQuerySchema),
    additional_documents: z.array(fileQuerySchema),
    recruiting_job_categories: z.array(recruitingJobCategoryQueryLinkerSchema),
    hiring_criteria_categories: z.array(recruitingHiringCriteriaCategoryQueryLinkerSchema),
    phone_numbers: z.array(phoneNumberQuerySchema),
    recruiting_tags: z.array(tagsFormSchema),
    notes: z.string(),
  });

export type RecruitingFormSchema = z.infer<typeof recruitingFormSchema>;
